<template>
  <div class="forgotPass">
    <Header />
    <div class="forgotPass__menu">
      <Menu />
      <div class="container">
        <div class="container__content">
          <span
            class="container__title"
            tabindex="0"
            aria-label="Reset hasła"
          >
            Reset hasła
          </span>
          <span
            class="container__subtitle"
          >
            W celu dokonania zmiany, wpisz nowe hasło.
          </span>
          <div class="forgotPass__content">
          <form>
            <LoginModalInput
              type="password"
              placeholder="Nowe hasło"
              v-model="newPassword"
              tabindex="0"
              aria-label="W celu dokonania zmiany, wpisz nowe hasło."
            />
            <LoginModalInput
              type="password"
              placeholder="Powtórz nowe hasło"
              v-model="repeatPassword"
              tabindex="0"
              aria-label="Powtórz hasło"
            />
          </form>
        </div>
        <span
          class="login__invalid"
          v-if="invalid"
          tabindex="0"
          aria-label="Podane hasła nie zgadzają się."
        >
          Podane hasła nie zgadzają się.
        </span>
         <span
          class="login__invalid"
          v-if='this.errorMsg.length > 1'
          tabindex="0"
          aria-label="Podane hasła nie zgadzają się."
        >
          {{this.errorMsg}}
        </span>
        <div class="forgotPass__buttons">
          <SelectButton buttonName="Zatwierdż" :action="this.reset" />
        </div>
      </div>
      <div class="container__background" />
    </div>
  </div>
  <Rodo/>
</div>
</template>

<script>
import Header from "@/components/Header/Desktop/Header.vue";
import Menu from "@/components/Menu/Desktop/Menu.vue";
import LoginModalInput from "@/ui/LoginModalInput.vue";
import SelectButton from '@/ui/SelectButton.vue';
import Rodo from '@/components/Rodo/Desktop/Rodo.vue';
import mixin from '../mixin.js';

export default {
  mixins: [mixin],
  components: {
    Header,
    Menu,
    LoginModalInput,
    SelectButton,
    Rodo
  }
};
</script>

<style scoped lang="scss">
.forgotPass {
    &__buttons {
        width: 15%;
            margin-left: 6%;

    }
    &__content {

    display: flex;
   margin-top: 2rem;
    flex-direction: column;
    width: 60%;
    margin-left: 6%;
    font-family: "Poppins", sans-serif;
    justify-content: space-between;
    height: 8rem;

    }
    .login__invalid {
   color: red;
   margin: 0.2rem 0;
   padding: 0rem 2.5rem;
       font-family: "Poppins", sans-serif;

 }
  &__menu {
    margin-top: -17rem;
  }
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex: 1;
    margin-top: 1.25rem;

    &__subtitle {
      font-family: "Poppins", sans-serif;
      font-size: 0.875rem;
      line-height: 1.375rem;
      display: block;
      margin-left: 6%;
      margin-top: 2.25rem;
    }

    &__content {
      width: 67%;
      height: 100%;
      background-color: #fefefe;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      height: 960px;
    }
    &__background {
      width: 33%;
      background-image: url("~@/assets/teamAside__background.png");
      background-size: 100%;
      background-position: top;
      background-repeat: no-repeat;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    &__title {
      margin-left: 6%;
      font-size: 1rem;
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      position: relative;
      margin-top: 40px;
      display: inline-block;
      &:after {
        content: "";
        position: absolute;
        width: 0.7rem;
        height: 0.7rem;
        background-color: #df2860;
        left: -1rem;
        top: 5%;
      }
    }
  }
  &__form {
    display: flex;
    flex-direction: column;
    width: 75%;
    margin-top: 1.2rem;
    margin-left: 6%;
    font-family: "Poppins", sans-serif;
  }
  &__label {
    margin-top: 1.8rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }
  &__input {
    width: 70%;
    height: 3rem;
  }
  &__agreement {
    font-size: 10px;
    margin-top: 1.3rem;
    line-height: 0.9rem;
    overflow: hidden;
    max-height: 0.9rem;
    transition: max-height 0.3s ease-in-out;
    &--active {
      max-height: 100vh;
    }
  }
  &__textarea {
    height: 12.8rem;
  }
  &__submit {
    width: 25%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    border: none;
    border-radius: 5px;
    color: #fafafa;
    letter-spacing: 0.8px;
  }
  &__hide {
    height: 1rem;
    margin-top: 2rem;
    margin-bottom: 2.5rem;
    display: flex;
    width: 4rem;
  }
  &__arrow {
    width: 0.9rem;
    height: 0.9rem;
    background-size: contain;
    display: inline-block;
    &--up {
      background-image: url(~@/assets/arrowUp.png);
    }
    &--down {
      background-image: url(~@/assets/arrowDown.png);
    }
  }
  &__cursive {
    font-size: 0.8rem;
    font-style: italic;
    margin-left: 0.5rem;
    align-items: center;
  }
}
</style>
